import React from "react";
import { catColor, abbrev } from "@/planner/lib/vendy";
import { fileUrl } from "@/planner/lib/apiClient";

// A readable, text-first planogram slot tile.
export const SlotTile = ({ slot, product, onClick, selected, dragOver, dragProps, addMode }) => {
  const cat = product?.category || "Other";
  const color = catColor(cat);
  const empty = !product;
  const par = slot.par || 0;
  const cur = slot.current ?? 0;
  const low = par > 0 && cur < par;
  const out = cur === 0 && !empty;
  const addable = addMode && !empty;

  return (
    <button
      type="button"
      data-testid={`planogram-slot-${slot.slot_id}`}
      onClick={onClick}
      {...(dragProps || {})}
      className={`relative flex min-h-[72px] w-full flex-col justify-between rounded-lg border p-2 text-left transition-[box-shadow,transform] hover:-translate-y-0.5 ${
        selected ? "ring-2 ring-primary" : ""
      } ${addable ? "ring-2 ring-green-500 cursor-copy" : ""} ${dragOver ? "ring-2 ring-primary bg-primary/5" : ""} ${empty ? "border-dashed" : ""}`}
      style={{
        background: empty ? "transparent" : color.bg,
        borderTopColor: out ? "#B91C1C" : low ? "#D97706" : undefined,
        borderRightColor: out ? "#B91C1C" : low ? "#D97706" : undefined,
        borderBottomColor: out ? "#B91C1C" : low ? "#D97706" : undefined,
        borderLeftColor: empty ? undefined : color.stripe,
        borderLeftWidth: empty ? undefined : 6,
        borderLeftStyle: empty ? undefined : "solid",
        color: color.text,
      }}
    >
      {addable && (
        <span className="absolute -right-1.5 -top-1.5 z-10 flex h-5 w-5 items-center justify-center rounded-full bg-green-600 text-[11px] font-bold text-white shadow" data-testid={`slot-add-badge-${slot.slot_id}`}>+1</span>
      )}
      <div className="flex items-center justify-between">
        <span className="font-mono text-xs font-semibold">{slot.slot_id}</span>
        {!empty && <span className="font-mono text-[10px] opacity-70">x{par}</span>}
      </div>
      {empty ? (
        <span className="text-[11px] font-medium text-muted-foreground">EMPTY</span>
      ) : (
        <>
          <div className="flex items-center gap-1.5">
            {product.image_path && <img src={fileUrl(product.image_path)} alt="" className="h-8 w-8 shrink-0 rounded border border-white/60 object-cover" data-testid={`slot-image-${slot.slot_id}`} />}
            <span className="text-[13px] font-semibold leading-tight">{abbrev(product.name, product.image_path ? 9 : 14)}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-[10px] font-medium opacity-80" data-testid={`slot-size-${slot.slot_id}`}>{abbrev([product.variant ? `(${product.variant})` : "", product.size].filter(Boolean).join(" "), 14) || "\u00a0"}</span>
            <span
              className={`rounded px-1.5 text-[10px] font-bold font-mono ${
                out ? "bg-red-600 text-white" : low ? "bg-amber-500 text-white" : "bg-white/70"
              }`}
            >
              {cur}/{par}
            </span>
          </div>
        </>
      )}
    </button>
  );
};
